import { render, staticRenderFns } from "./eod-add-productType.vue?vue&type=template&id=ff5e29f2"
import script from "./eod-add-productType.vue?vue&type=script&lang=js"
export * from "./eod-add-productType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports